// JS mirror of the custom media queries in src/assets/css/media.css, for the
// few places that pick a component by screen width (useMediaQuery). Keep the
// two files in sync: CSS cannot export @custom-media, JS cannot read it.
export const TABLET_LANDSCAPE_MEDIA = '(width >= 1024px)'
